/**
 * Page admin « Accès réseaux sociaux » (depuis le blog) — les identifiants des
 * Apps ; tout est aussi dans « Paramètres de connexion » (`/tutor/admin/connexions`).
 */

import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { SocialAppConfigsSection } from '@/features/connections/social-app-configs';

export function TutorAdminSocialSettingsPage() {
  return (
    <div className="mx-auto max-w-2xl p-4 pb-16 sm:p-6">
      <Link
        to="/tutor/blog"
        className="text-ink-500 hover:text-ink-900 mb-4 inline-flex items-center gap-1.5 font-sans text-[13px] transition-colors"
      >
        <ArrowLeft className="h-4 w-4" />
        Blog réflexif
      </Link>

      <h1 className="font-display text-ink-900 mb-1 text-[20px] font-extrabold">
        Accès réseaux sociaux
      </h1>
      <p className="text-ink-500 mb-5 font-sans text-[13px]">
        Renseigne les identifiants de tes Apps Meta, LinkedIn, TikTok et Google. Les secrets sont
        chiffrés côté serveur (jamais réaffichés). Comptes reliés, tests et clés du serveur :{' '}
        <Link to="/tutor/admin/connexions" className="text-primary-700 font-semibold underline">
          Paramètres de connexion
        </Link>
        .
      </p>

      <SocialAppConfigsSection />
    </div>
  );
}
